import { BRIDGE_MCP_SERVER_NAME } from './bridge-mcp-constants.js';
import { resolveBridgeMcpServerScriptPath } from './resolve-bridge-mcp-server-path.js';

/** ACP stdio MCP server entry (`session/new` `mcpServers`). @see https://agentclientprotocol.com/protocol/session-setup#mcp-servers */
export type AcpStdioMcpServer = {
  name: string;
  command: string;
  args: string[];
  env: Array<{ name: string; value: string }>;
};

/** Shared bridge MCP server; bridge access port is passed as the first CLI argument. */
export function buildAcpMcpServers(bridgeAccessPort: number): AcpStdioMcpServer[] {
  if (!Number.isFinite(bridgeAccessPort) || bridgeAccessPort <= 0) return [];

  return [
    {
      name: BRIDGE_MCP_SERVER_NAME,
      command: process.execPath,
      args: [resolveBridgeMcpServerScriptPath(), String(bridgeAccessPort)],
      env: [],
    },
  ];
}
